// Direct config instead of using next/config which has issues in Next.js 15
const config = () => ({
  client: {
    googleAnalyticsTrackingId: process.env.NEXT_PUBLIC_GA_ID || 'UA-143669093-1',
  },
  universal: {
    siteName: 'Everyday Rides',
    cookieKey: 'everydayrides',
    timezone: 'America/Los_Angeles',
    userLocationCookieKey: 'everydayrides_geolocation',
    graphqlUri: process.env.NEXT_PUBLIC_GRAPHQL_URI
      || (typeof window !== 'undefined'
        ? '/graphql'
        : `http://localhost:${process.env.PORT || 3000}/graphql`),
    baseUri: process.env.NEXT_PUBLIC_BASE_URI
      || (typeof window !== 'undefined'
        ? window.location.origin
        : (process.env.HEROKU_APP_NAME
          ? `https://${process.env.HEROKU_APP_NAME}.herokuapp.com`
          : 'https://everydayrides.com')),
    imagesBaseUrl: process.env.NEXT_PUBLIC_IMAGES_BASE_URL || 'https://images.everydayrides.com',
    primaryDomain: process.env.NEXT_PUBLIC_PRIMARY_DOMAIN || 'everydayrides.com',
    nativeLandApiKey: 'bSOCpn_mJc_t_CDUsFAEZ',
  }
});

export default config;
